<template lang="pug">
  v-layout.box-tarjeta-fecha-descarga(@click="download")
    v-flex(xs6 style="align-self: center;")
      span(style="font-size:15px; color: #454A6C;") {{textProp}}
    v-flex(xs4 style="align-self: center;text-align: end;" )
      span(style="font-size:14px; color: #0855C4;") Descarga
    v-flex(xs2 style="align-self: center;text-align: center;").box-tarjeta-fecha-descarga-icon
      v-img
        img(:src="iconDescarga")
      
  
</template>

<script>
export default {
  props: [
    "textProp",
    "iconDescarga"
  ],
  methods: {
    download() {
      this.$emit('downloadMethod')
    }
  },

}
</script>

<style scoped>
.box-tarjeta-fecha-descarga {
  border: 1px solid #D9D9D9;
  border-radius: 7px;
  padding: 1em;
}

.box-tarjeta-fecha-descarga:hover {
  background-color: #f9f9f9;
  border: 1px solid #0855C4 !important;
}

.box-tarjeta-fecha-descarga-icon {
  text-align: center;
}

.box-tarjeta-fecha-descarga-icon img {
  border-style: none;
  height: 15px;
  position: relative;
  top: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/generic/TarjetaFechaDescarga.vue